import { render, staticRenderFns } from "./PortfolioButton.vue?vue&type=template&id=92c2e124&"
import script from "./PortfolioButton.vue?vue&type=script&lang=js&"
export * from "./PortfolioButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports